export default class ResponsiveHeader {
    constructor() {
        this.resizeObserver = null;
        this.checkInterval = 200;
        this.lastCheckTime = 0;
        this.body = document.body;
        this.header = document.querySelector('header');
        if (!this.header)
            return;
        this.desktopHeader = this.header.querySelector('.row-desktop');
        this.logo = this.desktopHeader.querySelector('.col-logo');
        this.nav = this.desktopHeader.querySelector('.col-navigation');
        this.boundHandleResize = this.handleResize.bind(this);
        // initial check
        this.checkNavigationFit();
        // use resizeObserver if available, else fall back to resize listener
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.boundHandleResize);
            this.resizeObserver.observe(this.header);
            if (this.nav) {
                this.resizeObserver.observe(this.nav);
            }
        }
        else {
            window.addEventListener('resize', this.boundHandleResize);
        }
    }
    handleResize() {
        const now = Date.now();
        if (now - this.lastCheckTime > this.checkInterval) {
            this.checkNavigationFit();
            this.lastCheckTime = now;
        }
    }
    checkNavigationFit() {
        if (!this.logo || !this.nav)
            return;
        const headerContainer = this.header.querySelector('.container-fluid');
        const headerStyle = getComputedStyle(headerContainer);
        const availableWidth = this.header.clientWidth -
            parseFloat(headerStyle.paddingLeft) -
            parseFloat(headerStyle.paddingRight);
        const totalWidth = this.logo.clientWidth + this.nav.clientWidth;
        // check if already mobile to prevent toggling
        const isCurrentlyMobile = this.body.classList.contains('responsive');
        if (totalWidth > availableWidth && !isCurrentlyMobile) {
            this.body.classList.add('responsive');
        }
        else if (totalWidth <= availableWidth * 0.95 && isCurrentlyMobile) {
            // 5% buffer to prevent immediate toggle back
            this.body.classList.remove('responsive');
        }
    }
    destroy() {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.checkNavigationFit);
    }
}
